/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}         from './project.element';
import {ProjectElementType}     from './project.element.type';

import {BlobType}               from '../blob';
import {Project}                from '../project';
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";
/**
 *
 * @class ResultsElement
 *
 * @brief container for all the outputs of an simulation
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
@ProjectElementFactoryDecorator('ResultsElement')
export class ResultsElement extends ProjectElement {

  /** standard constructor */
  constructor(
    project: Project,
         id: string,
     parent: ProjectElement,
    publish?: boolean
  ) {

    super(project, id, ProjectElementType.Results);

    this._acceptsElements.push(ProjectElementType.Snapshots);
    this._acceptsBlobs.push(BlobType.None);

    this._enabled     = true;
    this._label       = 'Results';
    this._icon        = 'fas fa-arrow-left';
    this._elementKind = 'Results';

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring ResultsElement");
  }
}
